import { z } from 'zod'

import { PersonDisplay } from '@/models/features/display-column.models'

export interface ResidentVehicle {
  id: number
  licensePlate: string
  color?: string
  make?: string
  model?: string
  permitTag?: string | null
  year?: number | null
  source?: string | null
  clientId?: number
}

export const ParkingAssignmentTypeEnum = z.enum(['Unit', 'Resident', 'Unassigned'])
export type ParkingAssignmentType = z.infer<typeof ParkingAssignmentTypeEnum>

export interface UnitResident {
  id: number
  apartment: string
  avatar: string | null
  firstName?: string
  lastName?: string
  // Note: the resident's `User` - populated as their email
  user?: string | null
  phone?: string | null
  buildingNumber?: string | null
  street?: string | null
  active?: boolean
  moveInDate?: number | null
  moveOutDate?: number | null
  vehicles?: ResidentVehicle[]
}

export interface BuildingUnit {
  id: number
  unit: string
  unitId?: string
  unitType?: string
  buildingId?: number
  clientId?: number | null
  createdAt?: number
  updatedAt?: number
}

export interface ResidentParkingSpot {
  // Note: the BE's per-column person details - only the fields enabled in its settings (EL-15064)
  assigneeDisplay?: PersonDisplay
  createdAt: number
  updatedAt: number
  id: number
  parkingSpot: string
  buildingId: number
  fullName: string
  apartment: string
  avatar: string | null
  clientId: number
  vehicles: ResidentVehicle[]
  assignmentType?: 'Resident' | 'Unit' | 'Unassigned'
  isUnassigned?: boolean
  unit?: string | null
  residents?: UnitResident[]
  unitResidents?: UnitResident[]
}

// Note: id is optional, because new vehicles don't have an id yet. Source is not included, because it is not editable.
export type UpdateResidentVehicle = Omit<ResidentVehicle, 'id' | 'source'> & {
  id?: number
  residentId?: number | null
}

export type ResidentParkingSpotMinified = Pick<
  ResidentParkingSpot,
  'buildingId' | 'clientId' | 'createdAt' | 'id' | 'parkingSpot' | 'updatedAt'
>
